import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { IrcpProjeto } from '../../models/ircp-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ProjetoPermission } from '../../models/projeto-permission.model';
import { IrcpProjetoService } from '../../services/ircp-projeto.service';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-projeto-ircp-edit',
  templateUrl: './detalhe-projeto-ircp-edit.component.html',
  styleUrls: ['./detalhe-projeto-ircp-edit.component.scss']
})
export class DetalheProjetoIrcpEditComponent extends BaseFormComponent<IrcpProjeto> implements OnInit {

  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  projeto: ProjetoCadastro;
  audit: AtualizacoesAudit;
  actionLabel: string = 'Novo';
  dataFinal: string = '';
  list: any;
  listUsuario: any[];
  listOrgaos: any[];
  simNaoList: any[] = [
    { id: "0", label: "Não" },
    { id: "1", label: "Sim" },
  ];
  permissions: ProjetoPermission;
  canSave: boolean = false;

  constructor(
    private myService: IrcpProjetoService,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
    });
    this.listUsuario = this.activatedRoute.snapshot.data['listUsuario'];
    this.list = this.activatedRoute.snapshot.data['list'];
    this.initForm();
    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      elected_proposal: new FormControl('', [Validators.required]),
      ds_objective_project: new FormControl('', [Validators.required]),
      ds_convenient: new FormControl(''),
      agency_id: new FormControl(this.projeto?.agency_id, [Validators.required]),
      corede_id: new FormControl(0, [Validators.required]),
      city_id: new FormControl(null),
      year_ircp: new FormControl(null),
      year_loa: new FormControl(null),
      id_programa_tematico: new FormControl({ value: null, disabled: true }),
      id_programa: new FormControl({ value: null, disabled: true }),
      ppa_nro_acao: new FormControl({ value: null, disabled: true }),
      transfer_value: new FormControl(''),
      counterpart_value: new FormControl(''),
      global_value: new FormControl({ value: '', disabled: true }),
      fpe_identifier: new FormControl(''),
      pfircpproas: new FormArray([]),
      transfer_type_id: new FormControl(null),
      operational_status_id: new FormControl(null),
      manager: new FormControl(null),
      adjunct: new FormControl(null),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.canSave = this.entity.test1;

      if (!this.entity.test1) {
        this.form.disable();
      }

      this.form.patchValue(this.entity);

      if (this.entity.corede_id === null) {
        this.form.get('corede_id').setValue(0);
      }

      if (this.formValue('year_loa')) {
        this.anoLoa('year_loa', 'id_programa_tematico');

        if (this.entity?.id_programa_tematico) {
          this.form.get('id_programa_tematico').setValue(this.entity?.id_programa_tematico);
          this.anoLoa('id_programa_tematico', 'id_programa');

          if (this.entity?.id_programa) {
            this.form.get('id_programa').setValue(this.entity?.id_programa);
            this.anoLoa('id_programa', 'ppa_nro_acao');

            if (this.entity?.ppa_nro_acao) {
              this.form.get('ppa_nro_acao').setValue(this.entity?.ppa_nro_acao);
            }
          }
        }
      }

      this.audit = {
        ircp_id: this.entity.id
      };
    }
  }

  getFormArray(): FormArray {
    return this.form.get('pfircpproas') as FormArray;
  }

  voltar() {
    this.navigation.back(['projetos', 'projeto', this.idProjeto, 'ircp']);
  }

  getDataCreate(): IrcpProjeto {
    let data: IrcpProjeto;
    data = Object.assign({}, data, this.form.value);
    data.pf_id = this.idProjeto;

    return data;
  }

  formValid(): boolean {
    return true;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res) => {
              this.msgSuccess('IRCP alterado com sucesso!');
              EventSharedService.get('auditRefresh').emit();
              this.loaded();
            },
            error: (error) => {
              let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
              this.msgError(msg);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res) => {
              this.confirmation().subscribe(() => {
                this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'ircp', res.id,]);
              })
              this.loaded();
            },
            error: (error) => {
              let msg = error?.error?.message || (error?.error?.match(/{"message":"(.+)"}/)?.[1]) || '';
              this.msgError(msg);
              this.loaded();
            },
          })
        );
      }
    } else {
      this.markAsDirty();
    }
  }

  fieldMessageRequireds(field, index: number): boolean {
    return this.getFormArray().controls[index].get(field).invalid && this.getFormArray().controls[index].get(field).dirty;
  }

  fieldErrosFormArray(field, index: number) {
    return this.getFormArray().controls[index].get(field)?.errors;
  }

  dataMask(event, field) {
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9/]/g, '');
    this.form.get(field).setValue(sanitizedValue);
  }

  formValue(field) {
    return this.form.get(field)?.value;
  }

  maskCurrency(event, field) {
    let value = this.maskService.formatarMedidaFisica(event.target?.value, 2, 14);
    this.form.get(field).setValue(value);
    this.setGlobalValue();
  }

  setGlobalValue() {
    let value1 = Number(this.formValue('counterpart_value').replace(/\./g, '').replace(/,/g, '.'));
    let value2 = Number(this.formValue('transfer_value').replace(/\./g, '').replace(/,/g, '.'));
    this.form.get('global_value').setValue((Number(value1 + value2)).toLocaleString('pt-BR', { currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 2 }));
  }

  maskProa(element, index: number) {
    this.getFormArray().controls[index].get('proa_id').setValue(this.maskService.formatarNumProa(element.target.value));
  }

  anoLoa(fieldValue, field) {
    switch (field) {
      case 'id_programa_tematico':
        this.list.programa_tematico = null;
        this.list.programa = null;
        this.list.ppa_nro_acao = null;
        this.form.get('id_programa_tematico').disable();
        this.form.get('id_programa').disable();
        this.form.get('ppa_nro_acao').disable();
        this.form.get('id_programa_tematico').setValue(null);
        this.form.get('id_programa').setValue(null);
        this.form.get('ppa_nro_acao').setValue(null);
        break;

      case 'id_programa':
        this.list.programa = null;
        this.list.ppa_nro_acao = null;
        this.form.get('id_programa').disable();
        this.form.get('ppa_nro_acao').disable();
        this.form.get('id_programa').setValue(null);
        this.form.get('ppa_nro_acao').setValue(null);
        break;

      case 'ppa_nro_acao':
        this.list.ppa_nro_acao = null;
        this.form.get('ppa_nro_acao').disable();
        this.form.get('ppa_nro_acao').setValue(null);
        break;

      default:
        break;
    }

    let obj = { ppa: field };
    this.loading();
    this.addSub(
      this.myService.listPPA(this.formValue(fieldValue), obj).subscribe({
        next: (res) => {
          if (res.length) {
            this.list[field] = res;
            this.form.get(field).enable();
            this.loaded();
          }
        },
      })
    )
  }

  selectCities(e) {
    let id = e.id;
    if (e.id === 0) {
      this.form.get('city_id').setValue('');
    } else {
      this.form.get('city_id').setValue(9999999);
    }

    this.myService.listCitiesForCorede(id).subscribe({
      next: (res) => {
        this.list.city = res;
      }
    })
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir(): void {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: (res) => {
        this.loaded();
        this.confirmation('Deletado com sucesso').subscribe(() => {
          this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'ircp']);
        });
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error)
      }
    });
  }
}

